import React from "react"
import { useEffect, useState } from "react"

import Button from "../../material/button/Button"
import styles from './ModaluploadResults.module.css'


function ModaluploadResultsInput({ dataList, onClose, onSubmit }) {

    // useEffect(() => {
    //     console.log(dataList)
    // }, [])


    return (
        <div className={styles.overlay}>
            <div className={styles.modalController2}>
                <div className={styles.closeButton}>
                    <img onClick={() => { onClose() }} src={require('../../../asset/icon/close-icon.svg').default}></img>
                </div>
                <div className={styles.contentModal}>
                    <div className={styles.textTitle}>ยืนยันการบันทึกข้อมูล</div>
                    <hr className={styles.hrLine} />
                    <div className={styles.textTitle}>
                        <div>
                            กรุณาตรวจสอบข้อมูลอีกครั้ง
                        </div>
                        <div>
                            ก่อนทำการบันทึกลงในระบบ
                        </div>
                    </div>
                    <div className={styles.textSubtitle}>จำนวนทั้งหมด {dataList.length} คน</div>
                    <div className={styles.textDetail}>**ท่านสามารถแก้ไขข้อมูลได้ภายใน 24 ชั่วโมงหลังจากกดยืนยันการลงข้อมูล กรุณาตรวจสอบข้อมูลให้ถูกต้อง**</div>
                    <div className={styles.align} style={{ margin: '30px 0px' }}>
                        <Button disabled={dataList.length > 0 ? false : true} style={{ width: '200px' }} onClick={onSubmit}>บันทึกลงในระบบ</Button>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default ModaluploadResultsInput